import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Mark, MarkUpsert } from '../../_objects/mark';
import { HttpService } from '../http.service';
import { MarkContractService } from '../interfaces/mark-contract.service';

@Injectable({
  providedIn: 'root'
})
export class MarkOnlineService extends HttpService implements MarkContractService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // MK01 GET /api/v1/marks
  getMark(): Observable<Mark> {
    const endpoint = super.getEndpoint('marks');

    return this.http.get<Mark>(endpoint,
      {
        withCredentials: super.getWithCredentialsOption()
      });

  }

  // MK02 PUT /api/v1/marks
  upsertMark(markUpsert: MarkUpsert): Observable<Mark> {
    const endpoint = super.getEndpoint('marks');

    return this.http.put<Mark>(
      endpoint,
      markUpsert,
      { withCredentials: super.getWithCredentialsOption() }
    );
  }
}
